module.exports = __webpack_public_path__ + "img/kopsurat_permata_keluarga_sm.927520e3.png";